/**
 * Docs: https://www.sanity.io/docs/image-urls
 *
 * Currently work in progress. This is activated in next.config.js (currently deactivatet)
 */
import { IMAGE_MOBILE_SIZE_PX } from "@/app/(site)/_utils/misc"
import { buildImageUrl } from "@/sanity/lib/image"

export const sanityBaseUrl =
    process.env.NEXT_SANITY_BASE_IMAGE_URL || "https://cdn.sanity.io/images/"
interface SanityLoaderProps {
    src: string
    width: number
    quality?: number
    rect?: number[]
    height?: number
}

export default function sanityLoader({
    src,
    width,
    height,
    quality
}: SanityLoaderProps): string {
    /**
     * Keep these for future reference
     */
    // const isCentraMedia = typeof src === "string" && src.startsWith(centraBaseUrl)
    // const isStaticMedia = typeof src === "string" && src.startsWith("/_next/static")
    // const centraBaseUrl =
    //     (process.env.NODE_ENV as string) === "development" ||
    //     (process.env.NODE_ENV as string) === "qa" ||
    //     (process.env.NODE_ENV as string) === "test"
    //         ? "https://poc.centraqa.com/"
    //         : "https://poc.centracdn.net/"
    /**
     * End of future reference 🧠
     */

    const isSanityMedia =
        (typeof src === "string" && src.startsWith(sanityBaseUrl)) ||
        src.startsWith("image-")

    if (!isSanityMedia) {
        return src
    }

    // Remove query parameters from the asset id
    const assetId = src.split("?")[0]

    let url = buildImageUrl(assetId).width(width).auto("format").fit("clip").url() ?? ""

    if (src.endsWith(".gif")) {
        url += `&h=${Math.round(IMAGE_MOBILE_SIZE_PX / 2.5)}`
    }
    if (height) {
        url += `&h=${height}`
    }
    if (quality) {
        url += `&q=${quality}`
    }

    return url
}
